import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import Rutas from 'src/app/Models/Base/rutas';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-login-soporte',
  templateUrl: './login-soporte.component.html',
  styleUrls: ['./login-soporte.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule
    , MatButtonModule
    , MatIconModule
    , MatInputModule
    , MatFormFieldModule
    , MatSelectModule
    , CommonModule
  ]
})
export class LoginSoporteComponent {
  form: FormGroup;
  isHideOld = false;
  isHideNew = false;
  isHideRep = false;
  servicios: any[] = [
    { value: 'Soporte', viewValue: 'Soporte' },
    { value: 'Consultoria', viewValue: 'Consultoría' }
  ];

  constructor(
      public appStateService: AppStateService
      , @Inject(MAT_DIALOG_DATA) public payload: { accountID: string, token?: string }
      , private fb: FormBuilder) 
      {
        this.form = this.fb.group({
          clientid: ['', [Validators.required]],
          userid: ['', [Validators.required]],
          password: ['', [Validators.required]],
        });
        this.form.patchValue({
          userid: 'Consultoria',
        });
        
      }
  
  get FromAdmin():boolean{
    const rutas = new Set<string>([Rutas.ADMINISTRATION]) 
    return rutas.has(window.location.pathname.split('/')[1])
  }

  get OldPass():string{
    return this.form.get('oldPass')?.value || '';
  }
  get NewPass():string{
    return this.form.get('password')?.value || '';
  }
  get RepNewPass():string{
    return this.form.get('confirmPass')?.value || '';
  }

  hasError(index: number): boolean{
    if(!this.NewPass.length) return true;
    const value  = this.NewPass;
    const patterns = ['[a-z]+', '[A-Z]+', '[0-9]+', '[$&+,:;=?@#|<>.^*()%!-]'];
    switch (index) {
      case 1:
        return String(value).length < 10 || String(value).length > 50

      case 2:
        return !String(value).match(patterns[patterns.length - 1]) || false

      case 3:
        return !String(value).match(patterns[patterns.length - 2]) || false

      case 4:
        return !String(value).match(patterns[patterns.length - 3]) || false

      case 5:
        return !String(value).match(patterns[patterns.length - 4]) || false

      default:
        return false
    }
  }

  get isSamePass(){
    return (!!this.NewPass.length && !!this.RepNewPass.length) && this.NewPass===this.RepNewPass
  };

  get onValidation(): boolean {
    return this.form.invalid;
  }

  onSubmit(){
    this.appStateService.dialog.closeAll();
    const { value } = this.form;
      this.appStateService.onLoginSupport(value);
  };

}
